export default __webpack_public_path__ + "static/media/arrow_need_help.596792c6.svg";